/**
 * The one definition of which revision of a file is the latest.
 *
 * Loftware always rolls a file forward to a new, higher revision: an overwrite
 * and even a rollback both mint the next revision rather than re-activating an
 * older one. The highest revision is therefore the current one.
 *
 * Numeric collation (not plain string ordering) so `1.10` ranks above `1.9`.
 *
 * Browser-safe on purpose (`Intl.Collator` only): this package is also imported
 * by the frontend.
 */
const revisionCollator = new Intl.Collator('en', { numeric: true });

/** Sorts in place, latest revision first, and returns the same array. */
export const sortRevisionsLatestFirst = <T extends { revision: string }>(items: T[]): T[] =>
  items.sort((left, right) => revisionCollator.compare(right.revision, left.revision));

/** The highest revision of the given names, or null when there are none. */
export const highestRevision = (revisions: string[]): string | null =>
  revisions.reduce<string | null>(
    (best, candidate) =>
      best === null || revisionCollator.compare(candidate, best) > 0 ? candidate : best,
    null
  );
